import React, { Component } from "react";
import { Link } from 'react-router-dom';
import Home from '../../container/Home';
import '../../styles/modulos.css'

import chatbot from "../../assets/logo-chatbot.png";
import gmail from "../../assets/logo-gmail.png";
import whatsapp from "../../assets/logo-whatsapp.png";
import notifica from "../../assets/logo-notifica.png";
import sms from "../../assets/logo-sms.png";
import voip from "../../assets/logo-voip.png";


export default class ccd extends Component {

    render() {
        return (
            <Home menu={true} client={true} html={
                <>
                    <div className="modulos-wrapper">
                        <div className="usuarios-header">
                            <h4>Central de Comunicação Dommus</h4>
                        </div>
                        <div className="modulos-holder">
                          <div className="row">
                            <div className="col" style={{marginBottom: "30px"}}>
                                <div className="card-deck">
                                    <div className="card text-center" style={{width: "18rem"}}>
                                        <img src={gmail} className="rounded mx-auto d-block" alt="Dommus logo" style={{width: "150px"}} />
                                        <div className="card-body">
                                        <h5 className="card-title">Envio de E-Mail</h5>
                                        </div>
                                        <div className="card-footer">
                                        <Link to="/ccd/mail/" className="btn btn-secondary btn-lg btn-block">Acessar</Link>
                                        </div>
                                    </div>
                                    <div className="card text-center" style={{width: "18rem"}}>
                                        <img src={sms} className="rounded mx-auto d-block" alt="Dommus logo" style={{width: "190px"}} />
                                        <div className="card-body">
                                        <h5 className="card-title">Envio de SMS</h5>
                                        </div>
                                        <div className="card-footer">
                                            <button type="button" className="btn btn-secondary btn-lg btn-block">Acessar</button>
                                        </div>
                                    </div>
                                    <div className="card text-center" style={{width: "18rem"}}>
                                        <img src={voip} className="rounded mx-auto d-block" alt="Dommus logo" style={{width: "270px"}} />
                                        <div className="card-body">
                                        <h5 className="card-title">Ligação via VoIP</h5>
                                        </div>
                                        <div className="card-footer">
                                            <button type="button" className="btn btn-secondary btn-lg btn-block">Acessar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-100"></div>
                            <div className="col">
                                <div className="card-deck">
                                    <div className="card text-center" style={{width: "18rem"}}>
                                        <img src={notifica} className="rounded mx-auto d-block" alt="Dommus logo" style={{width: "210px"}} />
                                        <div className="card-body">
                                        <h5 className="card-title">Notificações</h5>
                                        </div>
                                        <div className="card-footer">
                                            <button type="button" className="btn btn-secondary btn-lg btn-block">Acessar</button>
                                        </div>
                                    </div>
                                    <div className="card text-center" style={{width: "18rem"}}>
                                        <img src={chatbot} className="rounded mx-auto d-block" alt="Dommus logo" style={{width: "150px"}} />
                                        <div className="card-body">
                                        <h5 className="card-title">Chatbot</h5>
                                        </div>
                                        <div className="card-footer">
                                            <button type="button" className="btn btn-secondary btn-lg btn-block">Acessar</button>
                                        </div>
                                    </div>
                                    <div className="card text-center" style={{width: "18rem"}}>
                                        <img src={whatsapp} className="rounded mx-auto d-block" alt="Dommus logo" style={{width: "150px"}} />
                                        <div className="card-body">
                                        <h5 className="card-title">Whatsapp</h5>
                                        </div>
                                        <div className="card-footer">
                                            <button type="button" className="btn btn-secondary btn-lg btn-block">Acessar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                      
                </>
            } />
        )
    }
}
